export const environment = {
  production: false,
  adminServerUrl: "https://api.kudo7.com/api/v1/",
  transactionPasswordEncryptKey: "confidentialApplication",
};